import MainHeader from './MainHeader/MainHeader'
import PublicHeader from './PublicHeader/PublicHeader'

export const Header = {
  Public: PublicHeader,
  Main: MainHeader,
}
